import {BarChart, GaugeChart, HeatmapChart, LineChart, PieChart, SankeyChart, ScatterChart} from 'echarts/charts';
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  MarkAreaComponent,
  MarkPointComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import {CanvasRenderer} from 'echarts/renderers';

/**
 * ECharts, cut down to what this app actually draws.
 *
 * Importing the package whole pulls every chart type it ships — maps, gauges, sankey, treemaps,
 * graphs — into the bundle, over five megabytes of it, for every user who opens a module. The
 * library is built to be assembled instead: `use` registers the pieces, and anything not registered
 * is never bundled.
 *
 * Adding a chart type or a component means adding it here. ECharts says so at runtime when one is
 * missing — it logs which component a series needs and draws nothing — so the failure is loud, but
 * only in a browser: a unit test that never renders a canvas will not catch it.
 */
echarts.use([
  BarChart,
  GaugeChart,
  HeatmapChart,
  LineChart,
  PieChart,
  SankeyChart,
  ScatterChart,
  // The grid carries the axes; the rest are the parts of the chrome we actually use.
  DataZoomComponent,
  GridComponent,
  // Switched off on the canvas, but ECharts still tracks the selection behind our own chips — that
  // is what rescales an axis when a curve is hidden.
  LegendComponent,
  // The state bands behind the curves.
  MarkAreaComponent,
  MarkPointComponent,
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  VisualMapComponent,
  CanvasRenderer,
]);

export {echarts};
